
import React, { useState } from 'react';

interface Props {
  user: any;
  className?: string;
  backgroundColor?: string; // Hex code without hash
}

export const UserAvatar: React.FC<Props> = ({ user, className, backgroundColor }) => {
    const [imgError, setImgError] = useState(false);
    
    // Construct Dynamic Fallback URL based on props
    const fallbackName = user?.displayName || user?.email || 'User';
    const bgParam = backgroundColor || 'random';
    const dynamicUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(fallbackName)}&background=${bgParam}&color=fff&size=128`;
    
    // Determine Source
    const originalSrc = user?.photoURL;
    
    // Check if the original source is likely a static/generated placeholder (like the Guest User mock data)
    // If it is, we want to override it with our dynamic theme color
    const isPlaceholder = originalSrc?.includes('ui-avatars.com');

    // Logic:
    // 1. If img load error, fallback to dynamic.
    // 2. If no original photo, fallback to dynamic.
    // 3. If it IS a placeholder AND we have a specific background color to enforce (theme), use dynamic.
    // 4. Otherwise (Real user photo), keep original.
    let activeSrc = originalSrc;

    if (imgError || !originalSrc) {
        activeSrc = dynamicUrl;
    } else if (isPlaceholder && backgroundColor) {
        activeSrc = dynamicUrl;
    }

    return (
        <img 
            src={activeSrc}
            alt={user?.displayName || "Profile"}
            className={className || "w-full h-full object-cover"}
            onError={() => setImgError(true)}
        />
    );
};
